import { cn } from "@/lib/utils";

type Props = {
    className?: string
}

const LoaderWithBackdrop = ({
    className = 'text-white'
}: Props) => {
    return (
        <div className='flex justify-center items-center fixed inset-0 w-screen h-screen z-[9999] backdrop-blur-[3px] bg-black/30'>
            <div className="flex">
                <div className={cn("flex justify-center content-center flex-col", className)}>
                    <div className="font-bold" style={{fontSize: 60}}>Collaborate</div>
                    
                    <div 
                        className="mx-auto my-0 rounded-full w-[2.5em] h-[2.5em] before:rounded-full before:w-[2.5em] before:h-[2.5em] after:rounded-full after:w-[2.5em] after:h-[2.5em] text-[10px] m-[80px_auto] relative indent-[-9999em] translate-z-0 before:content-[''] before:absolute before:top-0 after:content-[''] after:absolute after:top-0 after:left-[3.5em] before:left-[-3.5em] animate-load7 before:animate-load7 after:animate-load7"
                    >
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoaderWithBackdrop;
